module.exports = __webpack_public_path__ + "img/workout3.2d340b46.jpg";